export default __webpack_public_path__ + "static/media/header-porsche.ff6dbaf5.jpg";